<template>
  <div class="c-select-group">
    <Row :gutter="12">
      <Col span="12">
        <Row class-name="m-wrap">
          <Col class-name="m-box" v-for="box in resource" :key="box.id" :span="col">
            <group-box
              v-model="box.keyword"
              :title="box.title"
              :data="box.data"
              :level="box.level"
              :loading="box.loading"
              :disabled="box.disabled"
              @on-select="selectAll"
            >
              <group-item
                v-model="box.current"
                :data="box.data"
                :level="box.level"
                :keyword="box.keyword"
                :disabled="box.disabled"
                @on-child="pushChild"
                @on-select="selectAll"
              />
            </group-box>
          </Col>
        </Row>
      </Col>

      <Col span="6" offset="1" class-name="m-result">
        <div class="m-wrap m-box" v-if="Boolean(value.length)">
          <group-box :title="`已选${account ? '计划组' : '账号'} (${value.length})`" result>
            <div v-for="item in value" :key="item.id" class="c-pop-tip">
              <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
            </div>
          </group-box>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, mergeArray, getKeyOfData, timeout } from '@/common/js/utils'
import GroupBox from './group-box'
import GroupItem from './group-item'

import { queryGroupByAccountWithBudget } from '@/api/toutiao.local.model'
const reducePlan = (ret, arr) => {
  ret.forEach((met) => {
    if (met.campaign && met.check) {
      const bool = arr.map((t) => t.id).includes(met.id)
      !bool && arr.push(met)
    }
    if (met.children && met.children.length) arr = mergeArray(arr, reducePlan(met.children, arr))
  })
  return arr
}

export default {
  name: 'selectGroup',
  components: { GroupBox, GroupItem },
  props: {
    value: {
      type: Array
    },
    data: {
      type: Array
    },
    media: {
      type: [Number, String]
    },
    type: {
      type: Number
    },
    deliveryType: {
      type: String
    },
    bidType: {
      type: Number
    },
    account: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    result() {
      return this.account ? reducePlan(this.data, []) : this.data.filter((ret) => ret.check)
    },
    col() {
      return this.account ? 12 : 24
    }
  },
  methods: {
    initData() {
      let current = ''
      if (this.resource[0] && this.resource[0].current) current = this.resource[0].current
      const resLevel1 = [
        {
          title: '账号',
          level: 1,
          keyword: '',
          current,
          data: this.data
        }
      ]
      const resLevel2 = [
        {
          title: '推广计划',
          level: 2,
          current: '',
          keyword: '',
          data: []
        }
      ]
      if (this.account) {
        this.resource = [...resLevel1, ...resLevel2]
        this.updateResource()
      } else this.resource = [...resLevel1]
    },
    updateResource() {
      let current = this.resource[0].current
      // 定位到有选中广告组的账号
      if (!current) {
        this.data.some((ret) => {
          const hasCheck = ret.children && ret.children.some((met) => met.check)
          if (hasCheck) {
            current = ret.id
            return true
          }
        })
      }
      // 都没有定位到取第一个账号
      if (!current) this.data[0] && (current = this.data[0].id)
      this.pushChild({ level: 1, current })
    },
    selectAll({ level, check, cat }) {
      const index = level - 2
      let current = index > -1 ? this.resource[index].current : ''
      cat && (current = cat)
      // 修复单排账号全选
      if (level === 1 && !this.account) {
        this.data.forEach((ret) => {
          this.$set(ret, 'check', check)
        })
      } else {
        this.$emit('on-select', {
          check,
          current,
          list: this.data
        })
      }
    },
    pushChild({ level, current }) {
      const len = this.resource.length
      this.resource[level - 1].current = current
      if (level === 1 && this.account) {
        // 切换账号
        const index = this.data.findIndex((ret) => ret.id === current)
        const campaign = index > -1 ? this.data[index] : {}
        if (!campaign.xhr && this.resource[level]) {
          // 未加载过数据
          this.resource[level].loading = true
          queryGroupByAccountWithBudget({
            adAccountId: current,
            campaignType: this.type,
            onlyBudgetLimitLess: false,
            bidType: this.bidType,
            deliveryMethod: this.deliveryType
          }).then((data) => {
            if (typeof data === 'symbol') return
            this.resource[level].loading = false
            timeout(0).then(() => {
              this.resource.splice(level, len - level) // 删除原来的层级
              if (isArray(data)) {
                campaign.children = data.map((ret) => {
                  return {
                    check: false,
                    id: ret.adGroupId,
                    name: ret.adGroupName,
                    type: ret.promotedObjecType,
                    account: ret.adAccountId,
                    campaign: true
                  }
                })
              } else campaign.children = []
              campaign.xhr = true
              campaign.disabled = campaign.disabled || !campaign.children.length
              this.handleChildPush(campaign.children, campaign.disabled)
            })
          })
        } else {
          this.resource.splice(level, len - level) // 删除原来的层级
          this.handleChildPush(campaign.children, campaign.disabled)
        }
      }
    },
    handleChildPush(children, disabled) {
      const append = []
      const childId = (this.resource[1] && this.resource[1].current) || ''
      if (isArray(children) && children.length) {
        const index = children.findIndex((ret) => ret.id === childId)
        const child = index > -1 ? children[index].id : children[0].id
        append.push({
          title: '计划组',
          level: 2,
          current: child,
          keyword: '',
          disabled,
          data: children
        })
      } else {
        // 空账号
        append.push({
          title: '计划组',
          level: 2,
          current: '',
          keyword: '',
          disabled,
          data: []
        })
      }
      this.resource.push(...append)
    },
    handleClose(event, id) {
      const item = getKeyOfData(this.data, 'id', id)
      if (isArray(item.children) && item.children.length) {
        this.$emit('on-select', { list: this.data, check: false, current: id })
      } else {
        this.$set(item, 'check', false)
      }
    }
  },
  data() {
    return {
      resource: []
    }
  },
  created() {
    this.initData()
  }
}
</script>
<style lang="scss" scoped>
.c-select-group {
  width: 100%;

  .m-wrap {
    border-bottom: 1px solid #e8eaec;
    border-right: 1px solid #e8eaec;
  }

  .m-box {
    border-top: 1px solid #e8eaec;
    border-left: 1px solid #e8eaec;
  }

  .m-result {
    min-width: 320px;

    ::v-deep .c-content {
      height: 412px;
    }

    .c-pop-tip {
      width: 100%;
    }

    .c-tag-item {
      width: 90%;
      margin: 8px 8px 0;
      padding: 2px 6px;
      display: block;
      font-size: 14px;
      height: 28px;
    }
  }
}
</style>
